import { Popover as AriaPopover, type PopoverProps as AriaPopoverProps } from "react-aria-components";
import { cx } from "@/lib/cx";

export const popoverSurface =
  "popover-anim z-50 rounded-panel border border-popover-border bg-popover-bg text-fg shadow-lg outline-none";

/** Generic floating panel. Menus, selects and comboboxes use this internally. */
export function Popover({
  className,
  offset = 4,
  ...props
}: Omit<AriaPopoverProps, "className"> & { className?: string }) {
  return <AriaPopover offset={offset} className={cx(popoverSurface, "overflow-auto", className)} {...props} />;
}
